
import SEO from "../../components/SEO";
import HomeAboutSec from "./HomeAboutSec";
import HomeCtaBanner from "./HomeCtaBanner/HomeCtaBanner";
import HomeIndustriesWeServe from "./HomeIndustriesWeServe/HomeIndustriesWeServe";
import HomeOurClients from "./HomeOurClients/HomeOurClients";
import HomeOurGlobalPresence from "./HomeOurGlobalPresence/HomeOurGlobalPresence";
import HomeOurServiceSec from "./HomeOurServiceSec";
import HomeSec1 from "./HomeSec1/HomeSec1";
import HomeTestimonials from "./HomeTestimonials/HomeTestimonials";
import HomeWhyChooseUs from "./HomeWhyChooseUs/HomeWhyChooseUs";
import InsightResourceSec from "./InsightResourceSec/InsightResourceSec";
import OurProcessSection from "./OurProcessSection/OurProcessSection";

export default function Home({ currentLanguage = "en" }) {
  return (
    <>
      <SEO  title="Pestel And Partners" />
      <HomeSec1 currentLanguage={currentLanguage} />
      <HomeAboutSec currentLanguage={currentLanguage} />
      <HomeOurServiceSec currentLanguage={currentLanguage} />
      <HomeWhyChooseUs currentLanguage={currentLanguage} />
      <HomeOurGlobalPresence currentLanguage={currentLanguage} />
      <HomeIndustriesWeServe currentLanguage={currentLanguage} />
      <OurProcessSection currentLanguage={currentLanguage} />
      <HomeOurClients currentLanguage={currentLanguage}  />
      <HomeCtaBanner currentLanguage={currentLanguage}  />
      <HomeTestimonials currentLanguage={currentLanguage}  />
      <InsightResourceSec currentLanguage={currentLanguage} />
    </>
  );
}
